module.exports = __webpack_public_path__ + "img/tp.a60cb1dc.jpg";